import {
  IEngagement,
  IEngagementAddRequirementRequest
} from "@wingspanhq/payments/dist/interfaces";
import { WSMutationConfig } from "@ws-react-query";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import {
  QUERY_ENGAGEMENT,
  QUERY_ENGAGEMENT_LIST,
  QUERY_ENGAGEMENT_LIST_SIZE
} from "../keys";
import { addRequirementToEngagement } from "../../../services/engagements";
import {
  QUERY_REQUIREMENT_DEFINITIONS_LIST_ALL,
  QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE
} from "../../requirementDefinitions/keys";
import { QUERY_EXTENDED_REQUIREMENT_DEFINITIONS } from "../../requirementDefinitions/query/useQueryExtendedRequirementDefinitions";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../resourceEvents/queries/useQueryListEvents";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../../payeeEngagements/keys";

export const useMutationAddRequirementToEngagement = (
  id: string,
  config?: WSMutationConfig<IEngagement, WSServiceError>
) =>
  useWSMutation(
    (request: IEngagementAddRequirementRequest) =>
      addRequirementToEngagement(id, request),
    {
      ...config,
      dependencies: [
        QUERY_ENGAGEMENT_LIST,
        QUERY_ENGAGEMENT_LIST_SIZE,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_ALL,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE,
        QUERY_EXTENDED_REQUIREMENT_DEFINITIONS,
        QUERY_LIST_RESOURCE_EVENTS,
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL
      ],
      awaitDependencies: [[QUERY_ENGAGEMENT, id]]
    }
  );
